import { UserOpsOrdersWrapper } from "./ops-orders.style";
import { OpsOrdersUsersSection } from "./sections/ops-orders-users.section";

export const OpsOrdersUsersPage = () => <UserOpsOrdersWrapper><OpsOrdersUsersSection /></UserOpsOrdersWrapper>;
